import React, { PureComponent } from "react";
import { connect } from 'react-redux';

import envconfig from "../../envconfig/envconfig";
import * as action from "../../store/home/action";
import * as actionHeader from "../../store/shared/header/action";

import style from '../../assets/css/home/home.module.scss';
import bg04 from '../../assets/images/home/bg04.png';
import bg05 from '../../assets/images/home/bg05.png';
import bg06 from '../../assets/images/home/bg06.png';
import bg07 from '../../assets/images/home/bg07.png';
import bg08 from '../../assets/images/home/bg08.png';
import bg09 from '../../assets/images/home/bg09.png';

class Home extends PureComponent {
    componentDidMount() {
        const { state, handleNav, getYearbookList, getDataCount, getStatNews } = this.props;
        handleNav('current', '');
        getDataCount();
        getYearbookList()
        getStatNews();
        this.handleDrawEChart(state.currHotTab)
    }

    handleHotTab = (index) => {
        const {state, handleKeyValue} = this.props;
        const {currHotTab} = state;
        if (currHotTab !== index) {
            handleKeyValue('currHotTab', index);
            this.handleDrawEChart(index)
        }
    }

    handleDrawEChart = (currHotTab) => {
        const {
            state, drawEChart0, drawEChart1, drawEChart2, drawEChart3,
            drawEChart4, drawEChart5, drawEChart6, drawEChart7, drawEChart8
        } = this.props;
        if (currHotTab === 0) {
            drawEChart0(state.echart0, state.charts[0]);
            drawEChart1(state.echart1, state.charts[1]);
            drawEChart2(state.echart2, state.charts[2]);
            return;
        }
        if (currHotTab === 1) {
            drawEChart3(state.echart3, state.charts[0]);
            drawEChart4(state.echart4, state.charts[1]);
            drawEChart5(state.echart5, state.charts[2]);
            return;
        }
        if (currHotTab === 2) {
            drawEChart6(state.echart6, state.charts[0]);
            drawEChart7(state.echart7, state.charts[1]);
            drawEChart8(state.echart8, state.charts[2]);
        }
    }

    toNewsDetail = (item) => {
        const win = window.open();
        win.location.href = envconfig.rootUrl + `/censusBulletin/detail?fileId=${item.fileId}`;
        win.location.target = '_blank';
    }

    render() {
        const { dataCount, yearbookList, hotDataTabs, currHotTab, censusData, statNews, charts } = this.props.state;
        return (
            <div className={'container'}>
                <div className={style['banner']}>
                    <div className={'main'}>
                        <h4 className={style['title']}>National Population Census of China</h4>
                        <div className={style['content']}>
                            <div className={'row ' + style['row']}>
                                <p>
                                The National Population Census of China Database is a full-text database and census analysis system based on the data from the previous census by the statistics department of  Chinese government. China's national census is conducted once a decade, and there has been seven times so far. It is the First-Hand data to study the basic situation and periodic development changes of China's society, economy, labor force, housing stock, and population distribution,etc.
                                </p>
                            </div>
                            <div className={'row ' + style['row']}>
                                <label>Year Coverage：</label>
                                <span>
                                1953 onward
                                </span>
                            </div>
                            <div className={'row ' + style['row']}>
                                <label className={style['publish-type']}>
                                Publish the census data of the national and local government statistics departments in the form of Excel.
                                (In case of any difference between English translation and the original Chinese text, the Chinese edition shall prevail.)
                                </label>
                                <ul>
                                    <li>
                                        <div className={style['em']}>Titles</div>
                                        <div className={style['num']}>{`${dataCount.typeCount || 0}`}</div>
                                    </li>
                                    <li>
                                        <div className={style['em']}>Volumes</div>
                                        <div className={style['num']}>{`${dataCount.bookCount || 0}`}</div>
                                    </li>
                                    <li>
                                        <div className={style['em']}>Entries</div>
                                        <div className={style['num']}>{`${dataCount.itemCount || 0}`}</div>
                                    </li>
                                    <li>
                                        <div className={style['em']}>Statistical Data </div>
                                        <div className={style['num']}>{`${dataCount.dataCount || 0}`}</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <a
                            aria-label={'Explore More Resources'}
                            className={'btn btn-purple ' + style['btn-purple']}
                            href='./valueSearch?ky=Population'
                        >
                            Explore More Resources >
                        </a>
                    </div>
                </div>
                <div className={'wrap ' + style['wrap'] + ' ' + style['wrap-1']}>
                    <div className={'main ' + style['main']}>
                        <div className={style['right']}>
                            <h5 className={style['right-title']}>Statistical Data Analysis</h5>
                            <div className={style['title-underline']}/>
                            <p>According to the needs of the research topic, through customizing the region and index parameters, it can effectively support decision-making.</p>
                            <a
	                            aria-label={'Enter Statistical Data Analysis'}
                                className={'btn btn-purple ' + style['btn-purple']}
                                href={'./dataAnalysis?year=' + encodeURIComponent('2010')}
                            >
                                Enter
                            </a>
                        </div>
                        <div className={style['echart-content']}>
                            <h5 className={style['title']}>Popular Data</h5>
                            <div className={style['title-underline']}/>
                            <ul className={'clearfix ' + style['tab']} role="tablist" aria-label="Popular Data Tabs">
                                {
                                    hotDataTabs.map((item, index) => (
                                        <li
                                            key={index}
                                            className={currHotTab === index ? style['curr'] : ''}
                                            onClick={() => this.handleHotTab(index)}
                                            tabIndex="0"
                                            role="tab"
                                            aria-selected={currHotTab === index}
                                            aria-label={item}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    this.handleHotTab(index);
                                                }
                                            }}
                                        >
                                            {item}
                                        </li>
                                    ))
                                }
                            </ul>
                            <div className={'row ' + style['echart-list']}>
                                {
                                    charts.map((item, index) => (
                                        <div key={index} id={'Chart' + index} className={style['echart-box']}/>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'wrap ' + style['wrap'] + ' ' + style['wrap-2']}>
                    <div className={'main ' + style['main']}>
                        <h5 className={style['title']}>
                            {/*<span>Census Data</span>*/}
                            <span className={style['title-right']}>Census Data</span>
                        </h5>
                        <div className={style['title-underline']}/>
                        <div className={style['card-box']}>
                            {
                                censusData.map((item, index) => (
                                    <div className={style['card-item']} key={index}>
                                        <img src={item.icon} alt=""/>
                                        <div className={style['title-name']}>{item.name}</div>
                                        {
                                            item.itemList.map((cItem, cIndex) => (
                                                <a
	                                                aria-label={`View ${cItem.name}`}
                                                    className={style['entry-item']}
                                                    key={`child_${cIndex}`}
                                                    href={`./censusData/detail?nav=${encodeURIComponent('The Seventh Census(2020)')}&fileCode=${cItem.fileCode}`}
                                                    target='_blank'
                                                >
                                                    {cItem.name}
                                                </a>
                                            ))
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <img className={style['img-left']} src={bg04} alt=""/>
                    <img className={style['img-right']} src={bg05} alt=""/>
                </div>
                <div className={'wrap ' + style['wrap'] + ' ' + style['wrap-3']}>
                    <div className={'main ' + style['main']}>
                        <section className={style['census-data']}>
                            <a className={style['title']} href='./censusData'>Census Yearbooks</a>
                            <div className={style['title-underline']}/>
                            <div className={style['yearbook-box']}>
                                <div className={style['yearbook-list']}>
                                    {
                                        Array.isArray(yearbookList) && yearbookList.map((item, index) => (
                                            <a
	                                            aria-label={item.yearbookCHName}
                                                key={index}
                                                className={style['yearbookItem']}
                                                style={{backgroundImage: 'url(' + item.coverImageUrl + ')'}}
                                                href={'./censusData/single?nav=&code=' + item.number + '&pykm=' + item.pinyinCode}
                                            />
                                        ))
                                    }
                                </div>
                            </div>
                        </section>
                        <section className={style['stat-news']}>
                            <h5 className={style['title']}>Census Bulletin</h5>
                            <div className={style['title-underline']}/>
                            <div className={style['news-content']}>
                                {
                                    statNews.map((item, index) => (
                                        <div className={style['box']} key={index}>
                                            <div className={style['box-header']}>
                                                <div className={style['header-title']}>
                                                    {index === 0 ? 'National Census Bulletin' : 'Local Census Bulletin'}
                                                </div>
                                                <a aria-label={`View more${index === 0 ? 'National Census Bulletin' : 'Local Census Bulletin'}`} href={`./censusBulletin?flag=${index}`} className={style['header-link']}>
                                                More&nbsp;&gt;&gt;
                                                </a>
                                            </div>
                                            <ul>
                                                {Array.isArray(item) && item.map((cItem, cIndex) => (
                                                    <li
	                                                    tabIndex={0}
	                                                    role="button"
	                                                    key={`news_${cIndex}`}
	                                                    aria-label={`View ${cItem.chTitle}`}
	                                                    onClick={() => this.toNewsDetail(cItem)}
	                                                    onKeyDown={(e) => {
		                                                    if (e.key === 'Enter') {
			                                                    e.preventDefault();
			                                                    this.toNewsDetail(cItem);
		                                                    }
	                                                    }}
                                                    >
                                                        <div className={style['sort']}>{`0${cIndex + 1}`}</div>
                                                        <div className={'ellipsis ' + style['top']} title={cItem.chTitle}>
                                                            {cItem.chTitle}
                                                        </div>
                                                        <div className={style['bottom']}>
                                                            <span>{cItem.publishTime}</span>
                                                            <span className={'ellipsis ' + style['origin']} title={cItem.source}>{cItem.source}</span>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))
                                }
                            </div>

                            <img className={style['bg07']} src={bg07} alt=""/>
                            <img className={style['bg08']} src={bg08} alt=""/>
                            <img className={style['bg09']} src={bg09} alt=""/>
                        </section>
                    </div>
                    <img className={style['bg06']} src={bg06} alt=""/>
                </div>
            </div>
        );
    }
}

//需要渲染什么数据
function mapStateToProps(state) {
    return {
        state: state.home
    }
}

//需要触发什么行为
function mapDispatchToProps(dispatch) {
    return {
        handleNav: (key,value) => dispatch(actionHeader.handleKeyValue(key, value)),//导航
        handleKeyValue: (key, value) => dispatch(action.handleKeyValue(key, value)),
        getYearbookList: () => dispatch(action.getYearbookList()),
        getStatNews: () => dispatch(action.getStatNews()),
        getDataCount: () => dispatch(action.getDataCount()),
        drawEChart0: (data, chart) => dispatch(action.drawEChart0(data, chart)),
        drawEChart1: (data, chart) => dispatch(action.drawEChart1(data, chart)),
        drawEChart2: (data, chart) => dispatch(action.drawEChart2(data, chart)),
        drawEChart3: (data, chart) => dispatch(action.drawEChart3(data, chart)),
        drawEChart4: (data, chart) => dispatch(action.drawEChart4(data, chart)),
        drawEChart5: (data, chart) => dispatch(action.drawEChart5(data, chart)),
        drawEChart6: (data, chart) => dispatch(action.drawEChart6(data, chart)),
        drawEChart7: (data, chart) => dispatch(action.drawEChart7(data, chart)),
        drawEChart8: (data, chart) => dispatch(action.drawEChart8(data, chart)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)
